import { BlockType } from '../ArticleBodyRenderer/types';

export const HIGHLIGHT_SELECTION_HINT_ATTRIBUTE_NAME = 'data-hsh';

export enum HighlightSelectionHint {
  Text = 'text',
  Code = 'code',
  Caption = 'caption',
  Image = 'image',
  List = 'list',
  ListElement = 'listElement',
  Table = 'table',
  TableRow = 'tableRow',
  TableColumn = 'tableColumn',
}

export type THighlightBlock<T> = {
  type: BlockType;
  data: T;
  id: string;
};

export type TCodeHighlightBlockData = {
  code: string;
};
export type THeaderHighlightBlockData = {
  text: string;
};
export type TListHighlightBlockData = {
  content?: string;
  items: TListHighlightBlockData[];
};
export type TParagraphHighlightBlockData = {
  text: string;
};
export type TQuoteHighlightBlockData = {
  text: string;
  caption: string;
};
export type TTableHighlightBlockData = {
  content: string[][];
};

export type TCloudinaryImageHighlightBlockData = {
  file: {
    url: string;
  };
  caption: string;
};

export type THighlightBodyBlock =
  | THighlightBlock<TCodeHighlightBlockData>
  | THighlightBlock<THeaderHighlightBlockData>
  | THighlightBlock<TListHighlightBlockData>
  | THighlightBlock<TParagraphHighlightBlockData>
  | THighlightBlock<TQuoteHighlightBlockData>
  | THighlightBlock<TTableHighlightBlockData>
  | THighlightBlock<TCloudinaryImageHighlightBlockData>;

export type TArticleHighlight = {
  blocks: THighlightBodyBlock[];
  time: number;
  version: string;
};
